<template>
  <div class="m-the-modal-content-wrapper">
    <slot name="modal-body"></slot>
  </div>
</template>

<script>
export default {
  name: 'MoleculeTheModalContent'
}
</script>
